import { ReactNode } from "react";
import { TabContext, TabPanel } from "@material-ui/lab";

import { Tabs, Tab } from "~components/Tabs";

export const InfoPanel = ({ value, children }: { value: string; children: ReactNode }) => {
  return <TabContext value={value}>{children}</TabContext>;
};

InfoPanel.Tabs = Tabs;
InfoPanel.Tab = Tab;
InfoPanel.Panel = TabPanel;
